import React, { useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import "../../Styles/Header.css";
import Appbar from "../../Component/NavPannel/Appbar";
import DashboardRoutes from "../../Component/Layouts/DashboardLayout";
import { getCustodians } from "../../Redux/Actions/strategyService";
import { GetUserInfo } from "../../Redux/Actions/userStatusService";
import { useDispatch } from "react-redux";
import { useUser } from "../../Context/UserContext";
import { usePermissions } from "../../Context/PermissionContext";

const mdTheme = createTheme();

function DashboardMain() {
  const dispatch = useDispatch();
  const { userRole } = useUser();
  const { permissions, userRole: permissionUserRole } = usePermissions();

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        // Fetch custodians data
        await dispatch(getCustodians());
        
        // Fetch user information
        const userInfoResponse = await dispatch(GetUserInfo());

        
        if (userInfoResponse.payload?.statusCode === 200) {
          const userData = userInfoResponse.payload.data;

          
       
          
          // You can store this data in Redux state or use it for dashboard customization
          // For example, you might want to customize the dashboard based on user role or entity info
        } else {
          console.error("Failed to fetch user info for dashboard:", userInfoResponse);
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };

    fetchDashboardData();
  }, [dispatch, userRole, permissions, permissionUserRole]);
  
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ 
        display: "flex", 
        height: "100vh",
        overflow: "hidden"
      }}>
        <CssBaseline />
        <div className="sidebarsetting">
          <Appbar mainpage="Home" subpage="Dashboard" />
        </div>
        <DashboardRoutes />
      </Box>
    </ThemeProvider>
  );
}

export default DashboardMain;
